import {Container, Box, Grid, Button, Typography, Paper} from "@mui/material";
import {NavLink, useOutlet} from "react-router-dom";
import './profile.css';
import MobileUpBar from "../components/mobileUpBar";
import useMdDown from "../hooks/useRespCheck";
import {useState, useEffect} from "react";
import StyledMenuItems from "../components/StyledMenuItems";
import api from "../hooks/useApi"; // Импортируй axios-инстанс
import {useNavigate} from "react-router-dom";
import PageTitle from "../components/PageTitle";
import {requireSuperAdmin} from '../auth/guards';

export const loader = requireSuperAdmin;

export const isAdminUser = (user) => Boolean(user?.is_superadmin || user?.is_superuser);

export default function Admin() {
    const [userData, setUserData] = useState(null);
    const outlet = useOutlet();
    const navigate = useNavigate();
    const [isAuthorizedUser, setIsAuthorizedUser] = useState(true);

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const accessToken = getCookie("access");

                if (!accessToken) {
                    navigate("/login");
                    return;
                }

                const response = await api.get("/api/user/profile/", {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                const user = response.data;

                setUserData(user);
                const isAdmin = user.is_superadmin || user.is_superuser;

                setIsAuthorizedUser(isAdmin);

                // 🔐 защита админки
                if (!isAdmin && window.location.pathname.startsWith("/adminH123H")) {
                    navigate("/profile/details", {replace: true});
                }

            } catch (error) {
                if (error.response?.status === 401) {
                    navigate("/login");
                } else {
                    setIsAuthorizedUser(false);
                }
            }
        };

        fetchUserData();
    }, [navigate]);


    // Проверяем, есть ли группы, и приводим их к числам перед проверкой
    // const isAuthorizedUser =
    //     userData?.groups && userData.groups.map(Number).includes(1) || userData?.groups.map(Number).includes(2);
    // const isAuthorizedUser = true; // Временно всегда true

    return (
        <>
            <PageTitle title="Адмін-панель"/>
            {useMdDown() && (<MobileUpBar/>)}
            <Container maxWidth='xl'>
                <Box className='spacer-profile' marginBottom={{lg: '125px', xs: '20px'}}/>
                <Box>
                    <Grid container spacing={2} className='profile-links'>
                        {/* container for links */}
                        <StyledMenuItems item xs={12} md={3} container spacing={2} style={{height: 'fit-content'}}>
                            <Grid item xs={12}>
                                <Button fullWidth
                                        to='details'
                                        variant='contained'
                                        component={NavLink}
                                >
                                    <Typography variant='body1' color='text.primary'>
                                        Особисті дані
                                    </Typography>
                                </Button>
                            </Grid>
                            <Grid item xs={12}>
                                <Button fullWidth
                                        href="https://webmail.easyrentplace.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        variant="contained"
                                >
                                    <Typography variant='body1' color="text.primary">
                                        Пошта
                                    </Typography>
                                </Button>
                            </Grid>
                            {isAuthorizedUser && (
                                <>
                                    <Grid item xs={12}>
                                        <Button fullWidth to="rights" variant="contained" component={NavLink}>
                                            <Typography variant="body1" color="text.primary">
                                                Права користувачів
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button fullWidth to="/all-users" variant="contained" component={NavLink}>
                                            <Typography variant="body1" color="text.primary">
                                                Всі користувачі
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button fullWidth to="/new-user" variant="contained" component={NavLink}>
                                            <Typography variant="body1" color="text.primary">
                                                Створити нового користувача
                                            </Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button fullWidth to="/new-mail" variant="contained" component={NavLink}>
                                            <Typography variant="body1" color="text.primary">Створення пошти</Typography>
                                        </Button>
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button fullWidth to="/all-mailboxes" variant="contained" component={NavLink}>
                                            <Typography variant='body1' color="text.primary">Всі пошти</Typography>
                                        </Button>
                                    </Grid>
                                </>
                            )}

                        </StyledMenuItems>
                        <Grid item xs={12} md={9} container>
                            <Box width="100%" maxWidth="100vw">
                                <Paper style={{padding: '15px', outline: '1px solid #9A9FA4', display: 'flex'}}
                                       elevation={0}>
                                    {outlet || <PlaceholderComponent/>}
                                </Paper>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Container>
        </>
    );
}

const PlaceholderComponent = () => {
    return (
        <Box>
            <Typography>
                Перейдіть за посиланням у меню, щоб розпочати роботу.
            </Typography>
        </Box>
    )
}

function getCookie(name) {
    const matches = document.cookie.match(new RegExp(
        "(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
    ));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}
